import { render, staticRenderFns } from "./DeleteAssociation.vue?vue&type=template&id=616a8c30&"
import script from "./DeleteAssociation.vue?vue&type=script&lang=js&"
export * from "./DeleteAssociation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports